import React, { Component } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import 'react-quill/dist/quill.bubble.css'
import { saveNotes } from '../../../API/v1/ChatInterface'

export default class TextEditor extends Component {
  constructor(props) {
    super(props)
    this.state = { text: '' }
  }

  componentDidMount() {
    const { defaultValue } = this.props
    if (defaultValue) this.setState({ text: defaultValue })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.url !== this.props.url) {
      this.setState({ text: nextProps.defaultValue })
    }
  }

  render() {
    const { text } = this.state
    const { minimal, readOnly, refs } = this.props
    return (
      <div className={'text-editor'} ref={refs}>
        <ReactQuill
          value={text}
          theme={minimal ? 'bubble' : 'snow'}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          placeholder={'Too Silent. Like to add any notes?'}
          readOnly={readOnly}
        />
      </div>
    )
  }

  handleChange = (value) => {
    this.setState({ text: value })
    if (this.props.onChange) this.props.onChange(value)
  }

  handleBlur = async (previousRange, source, editor) => {
    const text = editor.getHTML()
    const { url, paramName } = this.props
    const data = {}
    data[paramName] = text
    if (this.props.onBlur) this.props.onBlur()
    return await saveNotes(url, data)
  }
}
